/* ★ POPUP GATE "KAD TIADA PRODUK TIKTOK" — sebelum Run TikTok (2026-10-06, lakaran diluluskan user).
 *
 * Muncul bila toggle "Pasang beg kuning" HIDUP dan larian mengandungi kad tanpa link produk
 * TikTok (cth produk Shopee). TIADA apa dijalankan sehingga pelanggan memilih. Peraturan +
 * sebab: utils/gateBegKuning.js. Dipakai KEDUA-DUA laluan Run TikTok (kalendar + tick kad).
 *
 * RUPA SAHAJA — pemanggil (WorkspaceView) yang menjalankan semula larian mengikut butang.
 * Portal ke <body>; token v3.9 dengan nilai sandaran supaya rupa LAMA (tiada token) pun kemas.
 * Kelas `s-root` pada panel = muka taip v3.9 (popup di luar pokok .s-root).
 *
 * senarai:    [{ id, nama, tanda: 'shopee' | 'tiada' }] — kad tanpa link TikTok
 * bilLain:    bilangan kad LAIN dalam larian (yang ada link TikTok)
 * semuaTiada: true → butang utama = "Post tanpa beg kuning"; false → "Langkau, Run yang lain"
 */
import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

const ID_TAJUK = 'popup-gate-beg-kuning-tajuk';

export default function PopupGateBegKuning({ buka, senarai, bilLain = 0, semuaTiada = false, onLangkau, onTanpaBeg, onBatal, T }) {
    const ada = buka && Array.isArray(senarai) && senarai.length > 0;

    // Escape = Batal. Hook WAJIB sebelum pulangan awal (peraturan hooks React).
    useEffect(() => {
        if (!ada) return undefined;
        const kekunci = (e) => { if (e.key === 'Escape') { e.stopPropagation(); onBatal?.(); } };
        window.addEventListener('keydown', kekunci, true);
        return () => window.removeEventListener('keydown', kekunci, true);
    }, [ada, onBatal]);

    if (!ada || typeof document === 'undefined') return null;

    const n = senarai.length;
    const garis = 'var(--s-line, rgba(0,0,0,.08))';
    const gayaButang = { width: '100%', minHeight: 38, padding: '8px 16px', borderRadius: 10, fontFamily: 'inherit', fontSize: 13, fontWeight: 600, lineHeight: 1.3, cursor: 'pointer' };

    return createPortal(
        <div
            role="presentation"
            onClick={() => onBatal?.()}
            style={{ position: 'fixed', inset: 0, zIndex: 10050, background: 'rgba(0,0,0,.62)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}
        >
            <div
                className="s-root"
                role="dialog"
                aria-modal="true"
                aria-labelledby={ID_TAJUK}
                onClick={(e) => e.stopPropagation()}
                style={{
                    boxSizing: 'border-box', width: '100%', maxWidth: 440, maxHeight: 'calc(100vh - 32px)',
                    padding: 20, display: 'flex', flexDirection: 'column', gap: 14,
                    background: 'var(--s-panel, #ffffff)', color: 'var(--s-ink, #262626)',
                    border: `1px solid ${garis}`, borderRadius: 'var(--s-r-lg, 16px)',
                    boxShadow: 'var(--s-shadow-modal, 0 24px 64px -20px rgba(0,0,0,.25))',
                }}
            >
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
                    <span style={{ flex: 'none', width: 34, height: 34, borderRadius: 999, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', background: 'var(--s-warn-soft, rgba(217,119,6,.12))', color: 'var(--s-warn, #D97706)' }}>
                        <span className="material-symbols-outlined" aria-hidden style={{ fontSize: 19 }}>remove_shopping_cart</span>
                    </span>
                    <div style={{ minWidth: 0 }}>
                        <h3 id={ID_TAJUK} style={{ margin: 0, fontSize: 16, fontWeight: 600, lineHeight: 1.35 }}>
                            {T('ws.gateBeg.tajuk', `${n} kad tiada produk TikTok`, { n })}
                        </h3>
                        <p style={{ margin: '4px 0 0', fontSize: 13, lineHeight: 1.5, color: 'var(--s-ink-2, #696969)' }}>
                            {T('ws.gateBeg.sebab', 'Beg kuning tidak boleh dipasang pada kad ini. Tiada apa-apa dijalankan lagi.')}
                        </p>
                    </div>
                </div>

                <div style={{ border: `1px solid ${garis}`, borderRadius: 10, overflowY: 'auto', minHeight: 0, maxHeight: 220, flex: '0 1 auto' }}>
                    {senarai.map((k, i) => (
                        <div key={k.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, padding: '9px 12px', borderTop: i === 0 ? 'none' : `1px solid ${garis}` }}>
                            <span title={k.nama} style={{ minWidth: 0, fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {k.nama || T('ws.common.noName', '(tanpa nama)')}
                            </span>
                            <span style={{
                                flex: 'none', fontSize: 11.5, fontWeight: 600, padding: '2px 8px', borderRadius: 999,
                                background: k.tanda === 'shopee' ? 'var(--s-warn-soft, rgba(217,119,6,.12))' : 'var(--s-fill, rgba(0,0,0,.04))',
                                color: k.tanda === 'shopee' ? 'var(--s-warn, #D97706)' : 'var(--s-ink-2, #696969)',
                            }}>
                                {k.tanda === 'shopee' ? 'Shopee' : T('ws.gateBeg.tandaTiada', 'Tiada link')}
                            </span>
                        </div>
                    ))}
                </div>

                <p style={{ margin: 0, padding: '10px 12px', borderRadius: 10, background: 'var(--s-fill, rgba(0,0,0,.04))', fontSize: 12.5, lineHeight: 1.5, color: 'var(--s-ink-2, #696969)' }}>
                    {semuaTiada
                        ? T('ws.gateBeg.petuaSemua', 'Video akan dihantar seperti biasa, cuma tanpa beg kuning. Tetapan "Pasang beg kuning" anda tidak berubah.')
                        : T('ws.gateBeg.petua', 'Untuk post kad ini tanpa beg kuning: matikan "Pasang beg kuning" di Control Panel, kemudian Run kad ini sahaja.')}
                </p>

                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                    <button
                        type="button"
                        onClick={() => (semuaTiada ? onTanpaBeg?.() : onLangkau?.())}
                        style={{ ...gayaButang, border: '1px solid var(--s-primary, #262626)', background: 'var(--s-primary, #262626)', color: 'var(--s-primary-ink, #FAFAFA)' }}
                    >
                        {semuaTiada
                            ? T('ws.gateBeg.tanpaBeg', `Post ${n} kad ini tanpa beg kuning`, { n })
                            : T('ws.gateBeg.langkau', `Langkau ${n} kad ini, Run ${bilLain} yang lain`, { n, m: bilLain })}
                    </button>
                    <button
                        type="button"
                        autoFocus
                        onClick={() => onBatal?.()}
                        style={{ ...gayaButang, border: '1px solid transparent', background: 'transparent', color: 'var(--s-ink-2, #696969)', fontWeight: 500 }}
                    >
                        {T('common.cancel', 'Batal')}
                    </button>
                </div>
            </div>
        </div>,
        document.body,
    );
}
